import { camelCase as _camelCase, snakeCase as _snakeCase, splitByCase, upperFirst } from "scule";

const STR_SPLITTERS = ["-", "_", "/", ".", " "] as const;

export function sentenceCase(str: string) {
	return upperFirst(
		splitByCase(str, STR_SPLITTERS)
			.map(part => part.toLocaleLowerCase())
			.join(" "),
	);
}

export function titleCase(str: string) {
	return splitByCase(str, STR_SPLITTERS)
		.map(part => upperFirst(part.toLocaleLowerCase()))
		.join(" ");
}

export function capitalize(str: string) {
	if (!str.length) return str;
	return str.charAt(0).toUpperCase() + str.slice(1);
}

export function replaceAfterFirstMatch(str: string, search: string, replace: string): string {
	const firstIndex = str.indexOf(search);

	if (firstIndex === -1) {
		return str; // No match found
	}

	return str.slice(0, firstIndex + search.length) + str.slice(firstIndex + search.length).replace(search, replace);
}

export const snakeCase = _snakeCase;
export const camelCase = _camelCase;
